export const MIN_SIDEBAR_WIDTH = 308;
export const MAX_SIDEBAR_WIDTH = 9999;
export const SIDEBAR_COLLAPSE_FACTOR = 0.65;
